import React, { useState } from 'react';
import { IconButton, InputAdornment, TextField, Tooltip } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useTranslation } from '../../../i18n/useTranslation';

interface Props {
    id: string;
    label: string;
    value: string;
    onChange: (value: string) => void;
    error: boolean;
    helperText: string;
    autoComplete: string;
}

// Password input styled like the one in the login form (LoginFormInside), with the show/hide toggle.
const PasswordField: React.FC<Props> = ({ id, label, value, onChange, error, helperText, autoComplete }) => {
    const { t } = useTranslation('translation');
    const [showPassword, setShowPassword] = useState<boolean>(false);

    return (
        <TextField
            InputLabelProps={{ shrink: true }}
            fullWidth
            id={id}
            name={id}
            size="small"
            label={label}
            type={showPassword ? 'text' : 'password'}
            variant="outlined"
            value={value}
            onChange={(event) => onChange(event.target.value)}
            error={error}
            helperText={helperText}
            autoComplete={autoComplete}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <Tooltip title={showPassword ? t('HIDE') : t('SHOW')}>
                            <IconButton onClick={() => setShowPassword((prev) => !prev)} edge="end">
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                        </Tooltip>
                    </InputAdornment>
                ),
            }}
        />
    );
};

export default PasswordField;
